import React from 'react';
import { IconProps } from '../../types/icon';

const CsvAltIcon: React.FC<IconProps> = ({ className, size = 16 }) => {
  return (
    <img
      src="/gitex-illustrations/CsvAltIcon.png"
      alt="CSV Spreadsheet"
      width={size}
      height={size}
      className={className}
      style={{ objectFit: 'contain' }}
    />
  );
};

export default CsvAltIcon;
